// extracted by mini-css-extract-plugin
module.exports = {"root":"CapsuleBanner_root__9rhFY","wrapper":"CapsuleBanner_wrapper__cw_uz","fixed":"CapsuleBanner_fixed__XrTGu","aspectRatioMoments":"CapsuleBanner_aspectRatioMoments__1g39T"};